<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <form-title>当前广告</form-title>
      </div>
      <div class="r">
        <el-button
          type="primary"
          @click="addAdvertising"
        >
          新建广告
        </el-button>
        <el-button
          type="primary"
          @click="advertisingSort"
        >
          广告排序
        </el-button>
      </div>
    </div>
    <info-panel class="content enable">
      <el-scrollbar>
        <div
          v-for="item in list.enable"
          :key="item.id"
          class="item"
        >
          <div class="item-header">
            <span class="title">
              {{ item.advertisingTitle }}
            </span>
            <span class="time">
              创建时间：{{ $time(item.createTime).format('YYYY/MM/DD HH:mm') }}
            </span>
          </div>
          <div class="item-desc">
            {{ item.advertisingDesc }}
          </div>
          <div class="item-bottom">
            <el-button @click="addAdvertising(item)">
              编辑
            </el-button>
            <el-button
              type="primary"
              @click="enbaleDisable(item,types.ADVERTISING_VALID_DISABLE)"
            >
              禁用
            </el-button>
            <el-button
              type="danger"
              @click="enbaleDisable(item,types.ADVERTISING_VALID_DELETE)"
            >
              删除
            </el-button>
          </div>
        </div>
      </el-scrollbar>
    </info-panel>
    <form-title>停用广告</form-title>
    <info-panel class="content disable">
      <el-scrollbar>
        <div
          v-for="item in list.disable"
          :key="item.id"
          class="item"
        >
          <div class="item-header">
            <span class="title">
              {{ item.advertisingTitle }}
            </span>
            <span class="time">
              创建时间：{{ $time(item.createTime).format('YYYY/MM/DD HH:mm') }}
            </span>
          </div>
          <div class="item-desc">
            {{ item.advertisingDesc }}
          </div>
          <div class="item-bottom">
            <el-button @click="addAdvertising(item)">
              编辑
            </el-button>
            <el-button
              type="primary"
              @click="enbaleDisable(item,types.ADVERTISING_VALID_ENABLE)"
            >
              启用
            </el-button>
            <el-button
              type="danger"
              @click="enbaleDisable(item,types.ADVERTISING_VALID_DELETE)"
            >
              删除
            </el-button>
          </div>
        </div>
      </el-scrollbar>
    </info-panel>
    <custome-Dialog
      :dialog-visible.sync="dialogVisible"
      :confirm-text="confirmText"
      :title="title"
      width="30%"
      @confirm="confirm"
      @close="close"
    >
      <el-scrollbar class="dialog-content">
        <div
          v-for="(item,index) in dialogEnable"
          :key="item.id"
          class="item"
        >
          <el-radio
            v-model="sortId"
            :label="item.id"
            @click.native="chooseEnable(index)"
          >
            {{ item.advertisingTitle }}
          </el-radio>
        </div>
      </el-scrollbar>
      <div class="sort">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-sort-up"
          :disabled="activeSortIndex === 0"
          @click="sortUp"
        >
          升序
        </el-button>
        <el-button
          plain
          type="primary"
          size="mini"
          icon="el-icon-sort-down"
          :disabled="activeSortIndex === dialogEnable.length-1"
          @click="sortDown"
        >
          降序
        </el-button>
      </div>
    </custome-Dialog>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import axClient from '@/services';
// import types, { isBoughtList, studentSearchList } from '@/config';
import formTitle from '@/components/common/formTitle.vue';
import infoPanel from '@/components/common/infoPanel.vue';
import types from '@/config';
import customeDialog from '@/components/common/dialog.vue';

export default {
  name: 'Home',
  components: {
    formTitle,
    infoPanel,
    customeDialog,
  },
  data() {
    return {
      types,
      dialogVisible: false,
      sortId: null,
      activeSortIndex: null,
      confirmText: '保存',
      title: '广告排序',
      list: {
        enable: [],
        disable: [],
      },
      dialogEnable: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 查询广告列表
    async getList() {
      const enable = await axClient.advertising.getList({ valid: 10 });
      const disable = await axClient.advertising.getList({ valid: 30 });
      this.list = {
        enable: enable.list,
        disable: disable.list,
      };
    },
    // 新增编辑广告
    addAdvertising(item) {
      this.$router.push({ name: 'AdvertisingCreate', params: { id: item.id } });
    },
    // 排序
    advertisingSort() {
      this.dialogEnable = this._.cloneDeep(this.list.enable);
      this.dialogVisible = true;
    },
    // 取消排序
    close() {
      this.dialogEnable = this._.cloneDeep(this.list.enable);
      this.dialogVisible = false;
      this.activeSortIndex = null;
      this.sortId = null;
    },
    // 启用禁用
    enbaleDisable(item, valid) {
      this.$confirm('确定禁用/启用/删除该广告？', item.advertisingTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.advertising.updateValid(
          {
            id,
            valid,
          },
        );
        if (data) {
          this.$message.success('启用/禁用/删除成功');
          this.getList();
        }
      });
    },
    // 确认
    async confirm() {
      const idArr = this.dialogEnable.map((v) => ({ id: v.id }));
      const data = await axClient.advertising.resetRank(idArr);
      if (data) {
        this.$message.success('排序成功');
      }
      this.getList();
      this.dialogVisible = false;
    },
    // 选择排序
    chooseEnable(index) {
      this.activeSortIndex = index;
    },
    // 升序
    sortUp() {
      this.dialogEnable.splice(this.activeSortIndex - 1, 0, (this.dialogEnable[this.activeSortIndex]));
      // 删除后一项
      this.dialogEnable.splice(this.activeSortIndex + 1, 1);
      console.log(this.list.enable);
      this.activeSortIndex -= 1;
    },
    // 降序
    sortDown() {
      this.dialogEnable.splice(this.activeSortIndex + 2, 0, (this.dialogEnable[this.activeSortIndex]));
      // 删除前一项
      this.dialogEnable.splice(this.activeSortIndex, 1);
      this.activeSortIndex += 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .content {
    ::v-deep .el-scrollbar__view {
      display: flex;
    }
    &.disable {
      .item {
        border-color: rgba($--base-color-black, 0.1);
        .item-header {
          background: rgba($--base-color-black, 0.4);
        }
        .item-desc {
          background: rgba($--base-color-black, 0.05);
        }
      }
    }
    .item {
      background: $--base-color-white;
      border: 1px solid $--base-color-main;
      border-radius: 3px;
      min-width: 358px;
      width: 358px;
      margin-right: 8px;
      margin-bottom: 16px;
      .item-header {
        padding: 10px 0 5px 0;
        background: $--base-color-main;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: $--base-color-white;
        span {
          &.title {
            font-size: 20px;
            font-weight: 500px;
            line-height: 28px;
          }
          &.time {
            font-weight: 300;
            font-size: 12px;
            line-height: 17px;
          }
        }
      }
      .item-desc {
        padding: 16px;
        background: rgba($--base-color-main, 0.1);
        font-weight: 300;
        font-size: 14px;
        line-height: 20px;
        color: $--base-color-black;
        height: 150px;
      }
      .item-bottom {
        padding: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
::v-deep .el-dialog {
    .el-dialog__body {
      padding: 15px;
    }
    .sort {
      display: flex;
      justify-content: flex-end;
    }
    .dialog-content{
        padding: 12px;
        height: 260px;
        border-radius: 3px;
        border: 1px solid rgba(#dadada, 1);
        margin-bottom: 15px;
    .item {
        color: rgba($--base-color-black, 1);
        padding: 5px;
        font-size: 14px;
        line-height: 16px;
        border-bottom: 1px solid rgba($--base-color-black, 0.1);
        cursor: pointer;
      }
    }
  }
</style>
